import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ParsedPreviewConfig } from "./ParsePreviewConfig";
import { useTranslation } from "react-i18next";
import { AxMediaPreview } from "./AxMediaPreview";
import { Content } from "@/lib/types";

export const AxMediaPreviewContentDialog: React.FC<{
  parsedPreviewConfig: ParsedPreviewConfig;
  onClose: () => void;
  contentDetails: Content;
}> = ({ parsedPreviewConfig, onClose, contentDetails }) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("content.preview")}</DialogTitle>
          <DialogDescription>
            <AxMediaPreview parsedPreviewConfig={parsedPreviewConfig} contentDetails={contentDetails} />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
